module.exports = __webpack_public_path__ + "img/other.cf838ecf.jpg";